
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PropertySearchPage = lazy(() => import('../pages/property-search/page'));
const PropertyDetailPage = lazy(() => import('../pages/property-detail/page'));
const NeighborhoodGuidePage = lazy(() => import('../pages/neighborhood-guide/page'));
const FirstTimeBuyerGuidePage = lazy(() => import('../pages/first-time-buyer-guide/page'));
const MortgageCalculatorPage = lazy(() => import('../pages/mortgage-calculator/page'));
const HomeValuationPage = lazy(() => import('../pages/home-valuation/page'));
const StagingTipsPage = lazy(() => import('../pages/staging-tips/page'));
const SellingTimelinePage = lazy(() => import('../pages/selling-timeline/page'));
const MarketReportsPage = lazy(() => import('../pages/market-reports/page'));
const MetroDetroitForecast2025Page = lazy(() => import('../pages/market-insights/metro-detroit-forecast-2025/page'));
const InterestRateTrends2025Page = lazy(() => import('../pages/market-insights/interest-rate-trends-2025/page'));
const NewConstructionBoom2025Page = lazy(() => import('../pages/market-insights/new-construction-boom-2025/page'));
const MLSSearchPage = lazy(() => import('../pages/mls-search/page'));
const IDXIntegrationPage = lazy(() => import('../pages/idx-integration/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/property-search',
    element: <PropertySearchPage />
  },
  {
    path: '/mls-search',
    element: <MLSSearchPage />
  },
  {
    path: '/idx-integration',
    element: <IDXIntegrationPage />
  },
  {
    path: '/property-detail/:id',
    element: <PropertyDetailPage />
  },
  {
    path: '/neighborhood-guide',
    element: <NeighborhoodGuidePage />
  },
  {
    path: '/mortgage-calculator',
    element: <MortgageCalculatorPage />
  },
  {
    path: '/home-valuation',
    element: <HomeValuationPage />
  },
  {
    path: '/staging-tips',
    element: <StagingTipsPage />
  },
  {
    path: '/selling-timeline',
    element: <SellingTimelinePage />
  },
  {
    path: '/market-reports',
    element: <MarketReportsPage />
  },
  {
    path: '/first-time-buyer-guide',
    element: <FirstTimeBuyerGuidePage />
  },
  {
    path: '/market-insights/metro-detroit-forecast-2025',
    element: <MetroDetroitForecast2025Page />
  },
  {
    path: '/market-insights/interest-rate-trends-2025',
    element: <InterestRateTrends2025Page />
  },
  {
    path: '/market-insights/new-construction-boom-2025',
    element: <NewConstructionBoom2025Page />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
